import { useEffect, useRef, useState } from "react"
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import TWEEN from '@tweenjs/tween.js'
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";//rebe加载器
import NavigationBar from "./components/NavigationBar";
import './App.css'

function App() {
  const getSize = () => {
    const threeMainDom = document.getElementById('threeMain')
    const width = threeMainDom ? threeMainDom.clientWidth : 100;
    const height = threeMainDom ? threeMainDom.clientHeight : 100;
    return { width, height, threeMainDom }
  }
  let renderer;
  let camera;
  let scene;
  let controls;
  useEffect(() => {
    threeStart()
  }, [])

  const threeStart = () => {
    initThree();
    initCamera();
    initScene();
    initLight();
    initControl();
    initObject();
    animation();
  }

  const initThree = () => {
    const { width, height, threeMainDom } = getSize()
    renderer = new THREE.WebGLRenderer({
      antialias: true
    })
    renderer.setSize(width, height)
    threeMainDom.appendChild(renderer.domElement)
  }

  const initCamera = () => {
    const { width, height } = getSize()
    camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 2000)
  }

  const initScene = () => {
    scene = new THREE.Scene()
    scene.background = new THREE.Color('#f4f9f7');
  }

  const initLight = () => {
    const pointlight = new THREE.PointLight('#fff', 0.5)
    pointlight.position.set(20, 50, -50);
    pointlight.castShadow = true;
    pointlight.shadow.mapSize.set(2048, 2048);
    scene && scene.add(pointlight);
  }

  const initControl = () => {
    const { threeMainDom } = getSize()
    if (!threeMainDom) return

    controls = new OrbitControls(camera, threeMainDom)
    // 使动画循环使用时阻尼或自转 意思是否有惯性
    controls.enableDamping = true;
    // 动态阻尼系数 就是鼠标拖拽旋转灵敏度
    controls.dampingFactor = 0.1;
    // 是否可以缩放
    controls.enableZoom = true;
    // 是否自动旋转
    controls.autoRotate = false;
    // controls.autoRotateSpeed = 100;
    // 设置相机距离原点的最近距离
    controls.minDistance = 5;
    // 设置相机距离原点的最远距离
    controls.maxDistance = 15;
    // 是否开启右键拖拽
    controls.enablePan = false;
    // 设置相机观察点
    const lookat = new THREE.Vector3(0, 0, 0)
    controls.target = lookat
    camera.lookAt(lookat)
    camera.position.set(0, 0, -13)

    // const lookat = new THREE.Vector3(7.3, -1.5, -10)
    // controls.target = lookat
    // camera.lookAt(lookat)
    // camera.position.set(7.6, -3, -0.5)

    // 缩放速度
    controls.zoomSpeed = 0.3
    // 旋转速度
    // controls.rotateSpeed = 0.3
    // 上下旋转角度
    controls.maxPolarAngle = Math.PI / 2
    controls.minPolarAngle = Math.PI / 2
  }

  const initObject = () => {
    // 坐标轴
    const point = []
    point.push(new THREE.Vector3(0, 0, 0))
    point.push(new THREE.Vector3(200, 0, 0))

    point.push(new THREE.Vector3(0, 0, 0))
    point.push(new THREE.Vector3(0, 200, 0))

    point.push(new THREE.Vector3(0, 0, 0))
    point.push(new THREE.Vector3(0, 0, 200))

    const geomety = new THREE.BufferGeometry().setFromPoints(point)
    const material2 = new THREE.LineBasicMaterial({ color: '#f00' })
    const line = new THREE.Line(geomety, material2)
    // scene && scene.add(line);

    // 加载hdr环境图
    const rgbeLoader = new RGBELoader();
    //资源较大，使用异步加载
    rgbeLoader.loadAsync("/launchScenarios/hdrModel.hdr").then((texture) => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      // console.log(texture);
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 0.6;

      //将加载的材质texture设置给背景和环境
      if (scene) {
        // scene.backgroundIntensity = 0.8
        // scene.background = texture;
        scene.environment = texture;
      }
    });

    const gltf = new GLTFLoader()
    gltf.load('/launchScenarios/mainModel.glb', g => {
      for (let k in g.scene.children) {
        const { name } = g.scene.children[k]
        if (name.indexOf('background') !== -1) {
          g.scene.children[k].receiveShadow = true; // 接收阴影
        }
        if (name.indexOf('shadow') !== -1) {
          g.scene.children[k].castShadow = true; // 接收阴影
        }
      }
      g.scene.position.y = -2.2
      renderer.shadowMap.enabled = true;
      scene && scene.add(g.scene);
    }, function (load) {
      const { loaded } = load

     
      const numberTag = document.querySelector('.loading-number')
      const loadingTag = document.querySelector('.loading-box')

      if (loaded >= 8605300) {
        new TWEEN.Tween({ zIndex: 99 })
          .to({ zIndex: -99 }, 200)
          .onUpdate(function (obj) {
            loadingTag.style.zIndex = obj.zIndex;
          })
          .start();

        new TWEEN.Tween({ zIndex: 99 })
          .to({ zIndex: -99 }, 200)
          .onUpdate(function (obj) {
            numberTag.style.zIndex = obj.zIndex;
          })
          .start();

      }

      new TWEEN.Tween({ innerHtml: 0 })
        .to({ innerHTML: 100 }, 30000)
        .onUpdate(function () {
          const number = (loaded / 8600000 * 100).toFixed(0)
          numberTag.innerHTML = number + '%';
        })
        .start();
    })
    gltf.load('/launchScenarios/gym.glb', g => {
      g.scene.position.set(-2.8, 0.5, -6.5)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/bangong.glb', g => {
      g.scene.position.set(-7.2, 1.6, -1.3)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/shop.glb', g => {
      g.scene.position.set(-0.6, 2.8, 7)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/shequ.glb', g => {
      g.scene.position.set(5, 1.3, 0)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/hotel.glb', g => {
      g.scene.position.set(4.5, 2, 5)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/jingqu1.glb', g => {
      g.scene.position.set(-2.5, 0, -1.6)
      scene && scene.add(g.scene)
    })

    gltf.load('/launchScenarios/jingqu2.glb', g => {
      g.scene.position.set(1, 0, 1.5)
      scene && scene.add(g.scene)
    })
  }

  const animation = () => {
    if (!scene) return
    controls && controls.update() //每一帧都需要更新
    TWEEN.update(); //tween更新
    let { x, y, z } = camera.position
    if (scene.children.length >= 9) {
      for (let i = 1; i < scene.children.length - 1; i++) {
        const item = scene.children[i];
        const name = item.children[0].name
        if (name === 'bangong') {
          scene.children[i].lookAt(-x.toFixed(2) - 5, -Number(y.toFixed(2)) + 1, -z.toFixed(2) - 1)
        } else if (name === 'shangchang') {
          scene.children[i].lookAt(-x.toFixed(2), -Number(y.toFixed(2)) + 2.5, -z.toFixed(2))
        } else if (name === '社区') {
          scene.children[i].lookAt(-x.toFixed(2) + 3.5, Number(y.toFixed(2)) + 1, -z.toFixed(2))
        } else if (name === 'hotel') {
          scene.children[i].lookAt(-x.toFixed(2) + 3.5, Number(y.toFixed(2)) + 1.5, -z.toFixed(2))
        } else {
          scene.children[i].lookAt(-x.toFixed(2), Number(y.toFixed(2)), -z.toFixed(2))
        }
      }
    }
    renderer.render(scene, camera)
    requestAnimationFrame(animation)
  }

  let clientX = useRef(0)
  let defaultCamera = useRef({ position: { x: 0, y: 0, z: 0 } });

  useEffect(() => {
    const { threeMainDom } = getSize()
    threeMainDom.addEventListener('mousedown', mouseClickDown)
    threeMainDom.addEventListener('mouseup', mouseClick)
    return () => {
      threeMainDom.removeEventListener('mousedown', (e) => { })
      threeMainDom.removeEventListener('mouseup', (e) => { })
    }
  }, [])
  const createCameraTween = (endPos, endTarget, callback) => {
    if (!camera) return
    new TWEEN.Tween({
      // 不管相机此刻处于什么状态，直接读取当前的位置和目标观察点
      x: camera.position.x,
      y: camera.position.y,
      z: camera.position.z,
      tx: controls.target.x,
      ty: controls.target.y,
      tz: controls.target.z,
    })
      .to({
        // 动画结束相机位置坐标
        x: endPos.x,
        y: endPos.y,
        z: endPos.z,
        // 动画结束相机指向的目标观察点
        tx: endTarget.x,
        ty: endTarget.y,
        tz: endTarget.z,
      }, 2000)
      .onUpdate(function (obj) {
        // 动态改变相机位置
        camera.position.set(obj.x, obj.y, obj.z);
        // 动态计算相机视线
        // camera.lookAt(obj.tx, obj.ty, obj.tz);
        controls.target.set(obj.tx, obj.ty, obj.tz);
        controls.update();//内部会执行.lookAt()
      }).onComplete(function () {
        callback && callback()
      })
      .start()
  }
  const mouseClickDown = (e) => {
    clientX.current = e.clientX
  }
  const mouseClick = (event) => {
    if (event.clientX !== clientX.current) return
    const raycaster = new THREE.Raycaster();
    // console.log('射线属性', raycaster.ray);
    var mouse = new THREE.Vector2();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera)

    const intersects = scene ? raycaster.intersectObjects(scene.children) : []

    // 根据它来判断点击的什么，length为0即没有点击到模型
    if (intersects.length) {
      handlePosition(intersects[0].object)
    }
  }
  const setData = (val) => {
    return Math.round(val * 100) / 100
  }
  const getStartRangle = () => {
    let { x, z } = camera.position
    console.log(camera.position);
    const tx = Math.abs(setData(x))
    const tz = Math.abs(setData(z))
    let hypotenuse = Math.sqrt(tx * tx + tz * tz)
    hypotenuse = setData(hypotenuse)
    let sin, angle = -Math.PI / 2;

    // 第一象限
    if (x > 0 && z > 0) {
      sin = tx / hypotenuse
      sin = setData(sin)
      angle = Math.asin(sin) / 2
    }
    // 第二象限
    if (x > 0 && z < 0) {
      sin = tz / hypotenuse
      sin = setData(sin)
      angle = - (Math.asin(sin) / Math.PI * 180 + 90) / 360 * Math.PI
    }
    // 第三象限
    if (x < 0 && z < 0) {
      sin = tx / hypotenuse
      sin = setData(sin)
      // angle = -Math.PI / 2 - Math.asin(sin)
      angle = - (Math.asin(sin) / Math.PI * 180 + 180) / 360 * Math.PI
    }
    // 第四象限
    if (x < 0 && z > 0) {
      sin = tz / hypotenuse
      sin = setData(sin)
      console.log(Math.asin(sin) / 2);
      // angle = -Math.PI / 4 * 3 - Math.asin(sin)
      angle = - (Math.asin(sin) / Math.PI * 180 + 270) / 360 * Math.PI
    }
    return angle
  }
  const handlePosition = (obj) => {
    const { name } = obj
    if (!scene) return
    const { x, y, z } = camera.position
    defaultCamera.current = { x, y, z }
    // 健身房
    if (name.indexOf('文本005') !== -1) {
      controls.enableRotate = false
      return createCameraTween({ x: -2.3, y: -7, z: -4.2 }, { x: -2.6, y: -1.6, z: 0 }, function () {
        showContent(document.getElementById('tag1'))
      })
    }
    // 办公室
    if (obj.name.indexOf('立方体005') !== -1) {
      controls.enableRotate = false
      const R = 12;
      new TWEEN.Tween({ angle: getStartRangle() }).to({ angle: -Math.PI }, 1000).onUpdate(function (obj) {
        camera.position.x = R * Math.cos(obj.angle);
        camera.position.z = R * Math.sin(obj.angle);
        camera.lookAt(0, 0, 0);
      }).start().onComplete(function () {
        createCameraTween({ x: -7.8, y: -1.6, z: -1.3 }, { x: 0, y: -1.6, z: -1 }, function () {
          showContent(document.getElementById('tag2'))
        })
      })
    }
    // 商场
    if (name.indexOf('文本003') !== -1) {
      controls.enableRotate = false
      const R = 12;
      new TWEEN.Tween({ angle: getStartRangle() }).to({ angle: Math.PI / 2 }, 1000).onUpdate(function (obj) {
        camera.position.x = R * Math.cos(obj.angle);
        camera.position.z = R * Math.sin(obj.angle);
        camera.lookAt(0, 0, 0);
      }).start().onComplete(function () {
        createCameraTween({ x: -1, y: 1, z: 7.7 }, { x: -1, y: 0.1, z: 0 }, function () {
          showContent(document.getElementById('tag3'))
        })
      })
    }
    // 酒店
    if (name.indexOf('立方体003') !== -1) {
      controls.enableRotate = false
      const R = 12;
      new TWEEN.Tween({ angle: getStartRangle() }).to({ angle: Math.PI / 4 }, 1000).onUpdate(function (obj) {
        camera.position.x = R * Math.cos(obj.angle);
        camera.position.z = R * Math.sin(obj.angle);
        camera.lookAt(0, 0, 0);
      }).start().onComplete(function () {
        createCameraTween({ x: 4.5, y: -2, z: 6 }, { x: -1, y: -1.4, z: 0 }, function () {
          showContent(document.getElementById('tag4'))
        })
      })
    }
    // 景区 设备1
    if (name.indexOf('立方体008') !== -1) {
      controls.enableRotate = false
      createCameraTween({ x: -2.9, y: -6.3, z: -1.7 }, { x: -12, y: -1, z: -1.5 }, function () {
        showContent(document.getElementById('tag5'))
      })
    }
    // 景区 设备2
    if (name.indexOf('jingqu2') !== -1) {
      controls.enableRotate = false
      createCameraTween({ x: 1, y: -2, z: 0 }, { x: 1, y: -1.2, z: 10 }, function () {
        showContent(document.getElementById('tag5'))
      })
    }
    // 社区
    if (name.indexOf('shequ') !== -1) {
      controls.enableRotate = false
      const R = 12;
      new TWEEN.Tween({ angle: getStartRangle() }).to({ angle: 0 }, 1000).onUpdate(function (obj) {
        camera.position.x = R * Math.cos(obj.angle);
        camera.position.z = R * Math.sin(obj.angle);
        camera.lookAt(0, 0, 0);
      }).start().onComplete(function () {
        createCameraTween({ x: 7.6, y: -3, z: -0.5 }, { x: 7.3, y: -1.5, z: -10 }, function () {
          showContent(document.getElementById('tag7'))
        })
      })
    }

    if (name === 'shadow247') {
      back()
    }
  }

  const back = (tag) => {
    hiddenContent(tag)
    const { x, y, z } = defaultCamera.current
    createCameraTween({ x, y, z }, { x: 0, y: 0, z: 0 }, function () {
      controls.enableRotate = true
    })
  }
  const hiddenContent = (tag) => {
    const divTag = document.getElementById(tag)
    new TWEEN.Tween({ opacity: 1, right: 24 })
      .to({ opacity: 0, right: -700 }, 500)
      .onUpdate(function (obj) {
        divTag.style.right = obj.right + 'px';
        divTag.style.opacity = obj.opacity;
      })
      .start();
  }
  const showContent = (divTag) => {
    new TWEEN.Tween({ opacity: 0, right: -700 })
      .to({ opacity: 1, right: 24 }, 500)
      .onUpdate(function (obj) {
        divTag.style.right = obj.right + 'px';
        divTag.style.opacity = obj.opacity;
      })
      .start();
  }

  return (
    <div>
      <NavigationBar></NavigationBar>
      <div id="threeMain" className="App"></div>
      <div className="loading-box">
        <img className="image" src="https://jmqfilepro.oss-cn-hangzhou.aliyuncs.com/admin/0/2023713/9e3cd15979ab409cbc50baf91be747a4.png" alt="" />
        <div className="loading-number">
          0%
        </div>
      </div>
      <div id="tag1" className="content">
        <div className="back" onClick={() => back('tag1')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">健身房和运动场馆</p>
        <p className="p3">健身人士和运动员通常需要进行大量的运动和训练，导致肌肉疲劳和酸痛。</p>
        <p className="p4">共享筋膜枪可以为他们提供快速、有效的肌肉放松和恢复功能，同时也可以提升健身房或场馆的服务品质。</p>
      </div>
      <div id="tag2" className="content">
        <div className="back" onClick={() => back('tag2')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">办公场所</p>
        <p className="p3">长时间的坐姿和办公压力容易导致肌肉疲劳和不适，共享筋膜枪可以为办公场所提供一种健康的员工福利和服务。</p>
      </div>
      <div id="tag3" className="content">
        <div className="back" onClick={() => back('tag3')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">商场/商业区</p>
        <p className="p3">商场或商业区提供共享筋膜枪服务，丰富特色商业项目，有利于营造良好的商业氛围，提升商业体验，增强客流吸引力。</p>
      </div>
      <div id="tag4" className="content">
        <div className="back" onClick={() => back('tag4')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">酒店</p>
        <p className="p3">外出旅行或者工作出差时，紧凑的行程容易让人感到疲惫，酒店为客户提供共享筋膜枪服务，帮助客户缓解疲劳，提升用户体验进而帮助提高品牌形象。</p>
      </div>
      <div id="tag5" className="content">
        <div className="back" onClick={() => back('tag5')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">旅游景区</p>
        <p className="p3">旅游景区可以为游客提供共享筋膜枪服务，帮助游客缓解旅途疲劳和肌肉酸痛，提升游客的旅行体验和服务品质。</p>
      </div>

      <div id="tag7" className="content">
        <div className="back" onClick={() => back('tag7')}>返回</div>
        <p className="p1">投放场景/</p>
        <p className="p2">社区公共场所</p>
        <p className="p3">社区居民可以在公共场所租用共享筋膜枪进行肌肉放松和按摩，提高身体健康水平，同时也可以为社区居民提供便捷、健康的生活服务。</p>
      </div>

    </div>
  )
}
export default App